import ErrorIcon from '@mui/icons-material/Error';
import { LoadingButton } from '@mui/lab';
import { Tab, Tabs, Typography } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { Input } from '../../../../components/Input/Input';
import styles from './styles.module.css';
import { useServiceHubForm } from './useServiceHubForm';
import { UploadImage } from '../../../../components/UploadImage/UploadImage';
import { CreateServicesHubDto } from '../../../../types/serviceHub.types';
import { JsonEditor } from 'json-edit-react';
import { chooseFaqKeyAccordingToTab, chooseLangAccordingToTab, isServiceHubFaqArray } from './utils/utils';
interface ServiceHubFormProps {
  serviceHub: CreateServicesHubDto | null;
  action: (service: CreateServicesHubDto) => void;
}
export type ServiceHubFaq = { q: string; a: string };

export const ServiceHubForm = ({ serviceHub, action }: ServiceHubFormProps) => {
  const {
    formMethods,
    onSubmit,
    activeTabIndex,
    onTabClick,
    previewUrl,
    fileName,
    handleFileChange,
    isEnTabValid,
    isPlTabValid,
    isEuTabValid,
    isRuTabValid,
    loading,
    serviceFaq,
    setServiceFaq,
  } = useServiceHubForm({ serviceHub, action });
  const serviceName: any = `serviceName${chooseLangAccordingToTab(activeTabIndex)}`;
  const serviceSubtitle: any = `serviceSubtitle${chooseLangAccordingToTab(activeTabIndex)}`;
  const serviceShortname: any = `serviceShortname${chooseLangAccordingToTab(activeTabIndex)}`;
  const seoTitle = `seoTitle${chooseLangAccordingToTab(activeTabIndex)}`;
  const seoDescription = `seoDescription${chooseLangAccordingToTab(activeTabIndex)}`;
  const faqKey = chooseFaqKeyAccordingToTab(activeTabIndex);

  return (
    <div className={styles.container}>
      <FormProvider {...formMethods}>
        <Input
          required
          multiline
          name={'slug'}
          title="Service slug"
          placeholder="Enter Slug"
          formMethods={formMethods}
        />
        <div className={styles.upload}>
          <UploadImage
            previewUrl={previewUrl || ''}
            fileName={fileName}
            isDeleteBtnShouldBe={false}
            onChange={handleFileChange}
            name="fileInfo"
          />
        </div>
        <div className={styles.tabContainer}>
          <Tabs value={activeTabIndex} onChange={onTabClick}>
            <Tab label={<TabLabel label="Polish" isValid={isPlTabValid} />} />
            <Tab label={<TabLabel label="English" isValid={isEnTabValid} />} />
            <Tab label={<TabLabel label="Russian" isValid={isRuTabValid} />} />
            <Tab label={<TabLabel label="Ukranian" isValid={isEuTabValid} />} />
          </Tabs>
        </div>
        <div className={styles.infoContainer}>
          <Input
            required
            multiline
            name={serviceName}
            title="Service name"
            placeholder="Enter Service name"
            formMethods={formMethods}
          />
          <Input
            required
            multiline
            name={serviceSubtitle}
            title="Service subtitle"
            placeholder="Enter subtitle"
            formMethods={formMethods}
          />
          <Input
            required
            multiline
            name={serviceShortname}
            title="Service shortname"
            placeholder="Enter Service shortname"
            formMethods={formMethods}
          />
          <Input
            required
            multiline
            name={seoTitle}
            title="SEO Title"
            placeholder="Enter SEO Title"
            formMethods={formMethods}
          />
          <Input
            required
            multiline
            name={seoDescription}
            title="SEO Description"
            placeholder="Enter SEO Description"
            formMethods={formMethods}
          />
          <div className={styles.jsonEditor}>
            <p>FAQ Section</p>
            <JsonEditor
              data={serviceFaq[faqKey]}
              setData={(next) => {
                if (!isServiceHubFaqArray(next)) return;
                setServiceFaq((prev) => ({
                  ...prev,
                  [faqKey]: next,
                }));
              }}
            />
          </div>


        </div>
      </FormProvider>
      <LoadingButton variant="contained" loading={loading} onClick={onSubmit}>
        SAVE
      </LoadingButton>
    </div>
  );
};

const TabLabel = ({ label, isValid }: { label: string; isValid: boolean }) => {
  return (
    <div className={styles.tabItem}>
      <Typography variant="body1" color={isValid ? 'blue' : 'red'}>
        {label}
      </Typography>
      {!isValid && <ErrorIcon color="error" />}
    </div>
  );
};
